import { useState } from "react";
import { ActivityList } from "../../components/ActivityList";
import { ImportPanel } from "../../components/ImportPanel";
import { PageHead } from "../../components/ui";
import { t } from "../../i18n";

export function AthleteActivitiesPage({ orgId }: { orgId: string }) {
  const [reload, setReload] = useState(0);
  const href = (id: string) => `/org/${orgId}/atleta/atividades/${id}`;
  return (
    <>
      <PageHead
        title={t("Atividades")}
        subtitle={t("Envie os arquivos do seu relógio. Cada corrida é ligada ao treino do dia e comparada com o que o treinador prescreveu.")}
      />
      <ImportPanel orgId={orgId} uploadPath={`/orgs/${orgId}/me/imports`} activityHref={href} onImported={() => setReload((n) => n + 1)} />
      <ActivityList listPath={`/orgs/${orgId}/me/activities`} hrefFor={(a) => href(a.id)} reloadKey={reload} />
    </>
  );
}
